<script setup lang="ts">
import { computed } from 'vue';

const TEXT_COLOR_YES = '#284132';
const BG_COLOR_YES = '#c8ffdd';

const TEXT_COLOR_NO = '#432c27';
const BG_COLOR_NO = '#f4aa99';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellYesNo: ComponentWithProps<Props>;
  }
}

interface Props {
  value: boolean;
}

const props = defineProps<Props>();

const text = computed(() => {
  return props.value ? 'Yes' : 'No';
});

const style = computed(() => {
  return {
    color: props.value ? TEXT_COLOR_YES : TEXT_COLOR_NO,
    backgroundColor: props.value ? BG_COLOR_YES : BG_COLOR_NO,
  };
});
</script>

<template>
  <div class="score-table-cell">
    <span class="label-yes-no" :style="style">
      {{ text }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.label-yes-no {
  display: inline-block;
  padding: 2px 8px;
  text-align: center;
  border-radius: 10px;
  font-size: 12px;
}
</style>
